module.exports = __webpack_public_path__ + "images/emoji/speaker.afe8d0ab93d6773d26cf.png";